import React, { useEffect, useState} from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'

import Home from './Home'
import Login from './Login'
import Register from './Register'
import Gallery from './Gallery'
import Profile from './Profile'
import FamilyTree from './FamilyTree'
import Splash from './Splash'
import FamilyMembers from './FamilyMembers'
import FamilyMembersDeceased from './FamilyMembersDeceased'
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './queryClient';
import API_URL from './api/config';
import axios from 'axios';
import SearchPeople from './SearchPeople';
import SearchFamily from './SearchFamily';
import FamilySettings from './FamilySettings';
import FamilyPosts from './FamilyPosts';
import ProfileSettings from './ProfileSettings';
import FamilyRequests from './FamilyRequests';
import DeleteAccount from './DeleteAccount';
import DeactivateAccount from './DeactivateAccount';
import SignupTribe from './SignupTribe';
import SignupSubtribe from './SignupSubtribe';
import SignupSubgroup from './SignupSubgroup';
import SignupClan from './SignupClan';
import SignupTotem from './SignupTotem';
import SignupFamily from './SignupFamily';
import SignupCategory from './SignupCategory';
import SignupNoClan from './SignupNoClan';
import SignupNoTotem from './SignupNoTotem';
import SignupSelectFamily from './SignupSelectFamily';
import SignupSelectFamilyRedirect from './SignupSelectFamilyRedirect';
import ChatList from './ChatList';
import Chats from './Chats';
import FamilyTreeSpouse from './FamilyTreeSpouse';
import FamilyTreeSister from './FamilyTreeSister';
import EditPersonalInformation from './EditPersonalInformation';
import EditPersonalInfoSpouse from './EditPersonalInfoSpouse';
import EditPersonalInfoSister from './EditPersonalInfoSister';
import ForgotPassword from './ForgotPassword';
import ForgotPasswordReset from './ForgotPasswordReset';
import ForgotPasswordVerify from './ForgotPasswordVerify';
import FamilyEvents from './FamilyEvents';
import FamilySettingsEditClan from './FamilySettingsEditClan';
import FamilySettingsEditTotem from './FamilySettingsEditTotem';
import FamilyTree_2 from './FamilyTree_2';
import GalleryImages from './GalleryImages';
import ReportConcern from './ReportConcern';
import FamilyInfoUpdate from './FamilyInfoUpdate';
import FamilyInfoUpdateClan from './FamilyInfoUpdateClan';
import FamilyInfoUpdateClanAdd from './FamilyInfoUpdateClanAdd';
import FamilyInfoUpdateTotemAdd from './FamilyInfoUpdateTotemAdd';
import SignupHusbandDetails from './SignUpHusbandDetails';
import SignUpHusbandDetails from './SignUpHusbandDetails';
import FamilySettingsEditClanAdd from './FamilySettingsEditClanAdd';
import FamilySettingsEditTotemAdd from './FamilySettingsEditTotemAdd';
import PrintTreeOrder from './PrintTreeOrder';
import EditPersonalInfoSubscription from './EditPersonalInfoSubscription';
import PrintTreePreview from './PrintTreePreview';
import Home_2 from './Home_2';
import Timeline from './Timeline';
import FamilyInfoUpdateRelatedFamilies from './FamilyInfoUpdateRelatedFamilies';
import FamilySettingsTreeBackground from './FamilySettingsTreeBackground';
import VerifyInvitationInfoUpdate from './VerifyInvitationInfoUpdate';
import VerifyInvitationInfoConfirm from './VerifyInvitationInfoConfirm';
import VerifyInvitationReject from './VerifyInvitationReject';
import DeactivatedAccount from './DeactivatedAccount';
import { useFamilyAdmin } from './hooks/useFamilyAdmin';
import NeedHelp from './NeedHelp';
import SignUpGender from './SignUpGender';
import RegisterConfirm from './RegisterConfirm';
import FamilyNewsfeed from './FamilyNewsfeed';
 


function App() {

  

  const [user, setUser] = useState(null);

    useEffect(() => {
        axios.get(`${API_URL}/verify-user-api`, { withCredentials: true })
            .then(res => {
                if (res.data.Status === "Success") {
                    setUser(res.data.user);
                } else {
                    setUser(null);
                }
            })
            .catch(err => {
                console.error("User not logged in", err);
                setUser(null);
            });
    }, []);

  return (

    // "homepage": "https://oret.africa/tree/mobile",
    // basename="/tree/mobile"

    //oret_test
    

    <QueryClientProvider client={queryClient}>
    <BrowserRouter     >
      
      <Routes>
        <Route path='/' element={<Splash />} />
        <Route path='/home' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/family-tree' element={<FamilyTree />} />
        <Route path='/family-members' element={<FamilyMembers />} />
        <Route path='/family-members-deceased' element={<FamilyMembersDeceased />} />
        <Route path='/profile-settings' element={<ProfileSettings />} />
        <Route path='/search-people' element={<SearchPeople />} />
        <Route path='/search-family' element={<SearchFamily />} />
        <Route path='/family-settings' element={<FamilySettings />} />
        <Route path='/family-posts' element={<FamilyPosts />} />
        <Route path='/family-requests' element={<FamilyRequests />} />
        <Route path='/delete-account' element={<DeleteAccount />} />
        <Route path='/deactivate-account' element={<DeactivateAccount />} />
        <Route path='/sign-up-tribe' element={<SignupTribe />} />
        <Route path='/sign-up-subtribe' element={<SignupSubtribe />} />
        <Route path='/sign-up-subgroup' element={<SignupSubgroup />} />
        <Route path='/sign-up-clan' element={<SignupClan />} />
        <Route path='/sign-up-totem' element={<SignupTotem />} />
        <Route path='/sign-up-family' element={<SignupFamily />} />
        <Route path='/sign-up-category' element={<SignupCategory />} />
        <Route path='/sign-up-noclan' element={<SignupNoClan />} />
        <Route path='/sign-up-nototem' element={<SignupNoTotem />} />
        <Route path='/sign-up-select-family' element={<SignupSelectFamily />} />
        <Route path='/sign-up-select-family-redirect' element={<SignupSelectFamilyRedirect />} />
        <Route path='/chat-list' element={<ChatList />} />
        <Route path='/chat' element={<Chats />} />
        <Route path='/family-tree-spouse' element={<FamilyTreeSpouse/>} />
        <Route path='/family-tree-sister' element={<FamilyTreeSister/>} />
        <Route path='/edit-personal-information' element={<EditPersonalInformation/>} />
        <Route path='/edit-personal-info-spouse' element={<EditPersonalInfoSpouse/>} />
        <Route path='/edit-personal-info-sister' element={<EditPersonalInfoSister/>} />
        <Route path='/forgot-password' element={<ForgotPassword/>} />
        <Route path='/forgot-password-verify' element={<ForgotPasswordVerify/>} />
        <Route path='/forgot-password-reset' element={<ForgotPasswordReset/>} />
        <Route path='/family-events' element={<FamilyEvents/>} />
        <Route path='/family-settings-edit-clan' element={<FamilySettingsEditClan />} />
        <Route path='/family-settings-edit-totem' element={<FamilySettingsEditTotem />} />
        <Route path='/gallery-images' element={<GalleryImages />} />
        <Route path='/report-concern' element={<ReportConcern />} />
        <Route path='/family-info-update' element={<FamilyInfoUpdate />} />
        <Route path='/family-info-update-clan' element={<FamilyInfoUpdateClan />} />
        <Route path='/family-info-update-clan-add' element={<FamilyInfoUpdateClanAdd />} />
        <Route path='/family-info-update-totem-add' element={<FamilyInfoUpdateTotemAdd />} />
        <Route path='/sign-up-husband-details' element={<SignUpHusbandDetails />} />
        <Route path='/family-settings-edit-clan-add' element={<FamilySettingsEditClanAdd />} />
        <Route path='/family-settings-edit-totem-add' element={<FamilySettingsEditTotemAdd />} />
        <Route path='/print-tree-order' element={<PrintTreeOrder />} />
        <Route path='/edit-personal-info-subscription' element={<EditPersonalInfoSubscription />} />
        <Route path='/print-tree-preview' element={<PrintTreePreview />} />
        <Route path='/timeline' element={<Timeline />} />
        <Route path='/family-info-update-related-families' element={<FamilyInfoUpdateRelatedFamilies />} />
        <Route path='/family-settings-tree-background' element={<FamilySettingsTreeBackground />} />
        <Route path='/verify-invitation-info-update' element={<VerifyInvitationInfoUpdate />} />
        <Route path='/verify-invitation-info-confirm' element={<VerifyInvitationInfoConfirm />} />
        <Route path='/verify-invitation-reject' element={<VerifyInvitationReject />} />
        <Route path='/deactivated-account' element={<DeactivatedAccount />} />
        <Route path='/need-help' element={<NeedHelp />} />
        <Route path='/sign-up-gender' element={<SignUpGender />} />
        <Route path='/register-confirm' element={<RegisterConfirm />} />
        <Route path='/family-newsfeed' element={<FamilyNewsfeed />} />
        
        
    
        
      </Routes>
      
    </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
